import { Version } from '../utils/token-lists/token-lists.types'

export default function listVersionLabel(version: Version): string {
  return `v${version.major}.${version.minor}.${version.patch}`
}
